export const METIER_ASSOCIATION_MUSEE = 'metier.morale.musees';
export const METIER_ASSOCIATION_SECURITE_PRIVE = 'metier.morale.securite_privee';
export const METIER_ASSOCIATION_CONVOYEUR = 'metier.morale.convoyeur';
export const METIER_ASSOCIATION_FORMATION_SECURITE = 'metier.morale.formation_securite';
export const METIER_ASSOCIATION_PROTECTION_NAVIRE = 'metier.morale.protection_navire';
export const METIER_ASSOCIATION_FORMATION_ARMURERIE = 'metier.morale.formation_armurerie';
export const statutCnaps = [
    METIER_ASSOCIATION_SECURITE_PRIVE,
    METIER_ASSOCIATION_CONVOYEUR,
    METIER_ASSOCIATION_FORMATION_SECURITE,
    METIER_ASSOCIATION_PROTECTION_NAVIRE,
];

export const statutAfci = [METIER_ASSOCIATION_FORMATION_ARMURERIE];

export const PIECE_JOINTE_EXPLOITANT_TIR_FORAIN = 'exploitantTirForain';
export const PIECE_JOINTE_THEATRE_SOCIETE_PRODUCTION = 'theatreSocieteProduction';
export const PIECE_JOINTE_MUSEE_RAPPORT = 'rapportMusee';
export const PIECE_JOINTE_MUSEE_PIECES_JUSTIFICATIVES = 'piecesJustificativesMusee';
export const PIECE_JOINTE_NUISIBLES_PARCS_ZOOLOGIQUES_ESSAIS_INDUSTRIELS_STATUS =
    'nuisiblesParcsZoologiquesEssaisIndustrielsStatus';
export const PIECE_JOINTE_NUISIBLES_PARCS_ZOOLOGIQUES_ESSAIS_INDUSTRIELS_PIECE_IDENTITE =
    'nuisiblesParcsZoologiquesEssaisIndustrielsPieceIdentite';
export const PIECE_JOINTE_NUISIBLES_PARCS_ZOOLOGIQUES_ESSAIS_INDUSTRIELS_CERTIFICAT_MEDICAL =
    'nuisiblesParcsZoologiquesEssaisIndustrielsCertificatMedical';
export const PIECE_JOINTE_ASSOCIATION_FEDERATION_TIR_SPORTIF_ACTE_OFFICIEL_MINISTERE =
    'associationFederationTirSportifActeOfficielMinistere';
export const PIECE_JOINTE_ASSOCIATION_FEDERATION_TIR_SPORTIF_JUSTIFICATIF_REPRESENTANT_LEGAL =
    'associationFederationTirSportifJustificatifRepresentantLegal';
export const PIECE_JOINTE_ASSOCIATION_FEDERATION_TIR_SPORTIF_ETUDE_SURETE =
    'associationFederationTirSportifEtudeSurete';
export const PIECE_JOINTE_ASSOCIATION_FEDERATION_DECLARATION_COMPLEMENTAIRE =
    'associationFederationDeclarationComplementaire';
